import { LearningTypeFilter } from '@/features/catalog/admin/atoms/LearningTypeFilter';

type JourneyInsightsTabsLearningItemsTypeFilterProps = {
  selectedType: string;
  onChange: (selectedType: string) => void;
  onTrailingIconClick: VoidFunction;
};

export const JOURNEY_INSIGHTS_LEARNING_TYPES_OPTIONS = [
  { value: 'article', displayValue: 'Article', prefixIcon: ['far', 'memo'] },
  {
    value: 'practicalAssessment',
    displayValue: 'Assessment',
    prefixIcon: ['far', 'pen-line'],
  },
  { value: 'audio', displayValue: 'Audio', prefixIcon: ['far', 'microphone'] },
  { value: 'course', displayValue: 'Course', prefixIcon: ['far', 'road'] },
  { value: 'eLearning', displayValue: 'E-learning', prefixIcon: ['far', 'tv'] },
  { value: 'liveEvent', displayValue: 'Live event', prefixIcon: ['far', 'calendar'] },
  {
    value: 'onlineLearning',
    displayValue: 'On-demand learning',
    prefixIcon: ['far', 'computer-mouse'],
  },
  { value: 'path', displayValue: 'Path', prefixIcon: ['far', 'road'] },
  { value: 'resource', displayValue: 'Resource', prefixIcon: ['far', 'paperclip-vertical'] },
  { value: 'seminar', displayValue: 'Seminar', prefixIcon: ['far', 'presentation'] },
  { value: 'survey', displayValue: 'Survey', prefixIcon: ['far', 'square-poll-vertical'] },
  { value: 'video', displayValue: 'Video', prefixIcon: ['far', 'video'] },
  { value: 'webinar', displayValue: 'Webinar', prefixIcon: ['far', 'camera-web'] },
];

export const JourneyInsightsTabsLearningItemsTypeFilter = ({
  selectedType,
  onChange,
  onTrailingIconClick,
}: JourneyInsightsTabsLearningItemsTypeFilterProps): React.ReactElement => {
  return (
    <LearningTypeFilter
      options={JOURNEY_INSIGHTS_LEARNING_TYPES_OPTIONS}
      selectedLearningType={selectedType}
      onChange={onChange}
      onTrailingIconClick={onTrailingIconClick}
    />
  );
};
